module.exports = __webpack_public_path__ + "img/4.f78adc9d.jpg";